import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-30 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-xl text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line" aria-hidden="true"></i>
    </button>
  );
}